/** 
import different langs file,
if new locale is needed,
add and import a new locale folder in langs
**/

import zh_hk from './zh_hk'
import zh_cn from './zh_cn'
import en_us from './en_us'
import zh_mo from './zh_mo'

export default {
  translate: {
    en_us : en_us,
    zh_cn : zh_cn,
    zh_hk : zh_hk,
    zh_mo : zh_mo

  }
}


// WEBPACK FOOTER //
// ./src/langs/index.js